
import { useCurrencyInput, CurrencyDisplay } from 'vue-currency-input';
import { defineComponent, inject, onMounted, onUnmounted, ref, watch } from 'vue';

function vuetifyValidate (value: number|null, rules: Rules) {
    const errorBucket = []

    for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const valid = typeof rule === 'function' ? rule(value) : rule

        if (typeof valid === 'string') {
            errorBucket.push(valid)
        } else if (typeof valid !== 'boolean') {
            console.error(`Rules should return a string or boolean, received '${typeof valid}' instead`);
        }
    }

    return errorBucket;
};

type Rules = Array<string|((value: number|null) => boolean|string)>;

export default defineComponent({
    props: {
        label: {
            type: String,
            required: false,
        },
        value: {
            type: Number,
            required: false,
            default: null,
        },
        rules: {
            type: Array,
            required: false,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        "prepend-icon": {
            type: String,
            required: false,
            default: 'mdi-cash'
        }
    },
    setup(props) {
        const { formattedValue, inputRef, setValue, numberValue } = useCurrencyInput({
            currency: 'PLN',
            currencyDisplay: CurrencyDisplay.hidden,
            locale: 'pl-PL',
        });
        const validationErrors = ref<string[]>([]);
        function validate(value: number | null) {
            validationErrors.value = props.disabled ? [] : vuetifyValidate(value, props.rules as Rules);
            if (!props.disabled && value !== null && value < 0) {
                validationErrors.value.push('Cena nie może być ujemna');
            }
            if (validationErrors.value.length > 0) {
                console.log([ ...validationErrors.value ]);
            }

            return validationErrors.value.length === 0;
        }
        const form: any = inject('form');
        const validation = {
            _uid: Symbol(),
            props,
            ref: inputRef,
            $watch: () => () => validate(numberValue.value),
            validate: () => validate(numberValue.value),
            valid: () => validate(numberValue.value),
            shouldValidate: () => true,
            resetValidation: () => {
                validationErrors.value = [];
            },
        };

        onUnmounted(() => form.unregister(validation));

        onMounted(() => {
            form.register(validation);
            watch(
                numberValue,
                (currentValue) => {
                    validate(currentValue);
                }
            )
            watch(
                () => props.value as any,
                v => setValue(v), 
                {
                    immediate: true
                }
            );
            watch(
                () => props.disabled as any,
                v => {
                    if (v) validate(numberValue.value);
                }
            );
        });

        return {
            inputRef,
            formattedValue,
            validate: () => validate(numberValue.value),
            validationErrors 
        };
    },
});
